@for (toast of items(); track toast.id) {
  <dialab-toast
    [message]="toast.message"
    [variant]="toast.variant"
    [duration]="toast.duration"
    [showCloseButton]="toast.showCloseButton"
    (closed)="onDismiss()(toast.id)"
  />
}
